// Display helpers for server-owned, editable procurement structures.
// Templates are read from the workspace snapshot; there is no client-side template copy.
export function getTemplate(typeId, templates = []) {
  return templates.find(template => template.typeId === typeId) || { typeId, assemblies: [] };
}

export function getProjectTemplate(typeId, templates = []) {
  return getTemplate(typeId, templates).assemblies
    .filter(assembly => assembly.active !== false)
    .flatMap(assembly => (assembly.components || []).filter(component => component.active !== false)
      .map(component => ({ id: component.id, assemblyId: assembly.id, assembly: assembly.name, component: component.name })));
}

export function getProjectAssemblies(project) {
  if (!project) return [];
  if (Array.isArray(project.assemblies)) return project.assemblies;
  // Preserve readability while an older workspace receives its one-time server migration.
  return Array.from(new Set((project.items || []).map(item => item.assembly)))
    .map(name => ({ id: name, name, active: true }));
}

export function getItemAssembly(project, item) {
  const assemblies = getProjectAssemblies(project);
  return assemblies.find(assembly => assembly.id === item.assemblyId)
    || assemblies.find(assembly => assembly.name === item.assembly);
}

export function isItemActive(project, item) {
  return item.active !== false && getItemAssembly(project, item)?.active !== false;
}

export function getActiveItems(project) {
  return (project?.items || []).filter(item => isItemActive(project, item));
}

export function getTemplateCounts(typeId, templates = []) {
  const template = getTemplate(typeId, templates);
  const assemblies = template.assemblies.filter(assembly => assembly.active !== false);
  return { assemblies: assemblies.length, items: assemblies.reduce((total, assembly) => total + (assembly.components || []).filter(component => component.active !== false).length, 0) };
}
